const headers = {
  name: "Clear Customer Balance",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by invoice number",
      value: "",
    },
    {
      type: "range",
      name: "date",
      placeholder: ["Start Date", "End Date"],
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Customers",
        path: "/app/customers",
      },
      {
        name: "Clearing Balances",
        path: "",
      },
      {
        name: "Balance Logs",
        path: "/app/customers/balance-logs",
      },
    ],
  },
};

export default headers;
